<template>
  <el-radio-group v-model="sceneType"
                  class="inspector-radio-group"
                  :disabled="isSceneLoading"
                  @change="handleSceneSwitch">
    <el-radio-button :label="$t('Realogram')" />
    <el-radio-button v-if="isPlanogramActive"
                     :label="$t('Planogram')" />
  </el-radio-group>
</template>

<script>
export default {
  name: 'RealogramPlanogramSwitcher',
  props: {
    isPlanogramActive: {
      type: Boolean,
      default: false
    },
    isSceneLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sceneType: this.$t('Realogram')
    };
  },
  methods: {
    handleSceneSwitch() {
      this.$emit('input', this.sceneType);
    }
  }
};
</script>

<style lang="scss">
.el-radio-group {
  display: flex;
  flex-wrap: nowrap;

  &.inspector-radio-group {
    @include breakpoint(lg-max) {
      padding: 6px 0;
    }

    .el-radio-button {
      .el-radio-button__inner {
        font-size: 15px;
        font-weight: 600;
        line-height: 16px;
        text-transform: uppercase;
        border: none;
        border-radius: 40px;

        @include breakpoint(lg-max) {
          height: 26px;
          padding: 5px 15px;
        }
      }
    }
  }
}
</style>
